<template>
  <div class="card">
    <div class="card-body">
      <div style="position:relative;">
        <h2>Kodak Brand Managers</h2>
        <button type="button" class="btn btn-primary"
          style="position: absolute;right: 0;top: 0;"
          @click="openCreateModal"
        >
          <i class="fa fa-plus"></i> Create
        </button>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class="fa fa-search"></i>
                </span>
              </div>
              <input class="form-control" placeholder="search managers..." v-model="userFilter">
            </div>
          </div>
        </div>
      </div>
      <ul class="list-group">
        <li class="list-group-item"
          v-for="user in filteredUsers"
        >
          <div class="row">
            <div class="col-sm-4">{{ user.name }}</div>
            <div class="col-sm-4">{{ user.email }}</div>
            <div class="col-sm-3">
              <span v-if="user.isInvited">invite sent: {{ user.isInvited.created_at | datetime }}</span>
            </div>
            <div class="nowrap col-sm-1 text-right">
              <button type="button" class="btn btn-primary btn-sm"
                v-if="! user.isInvited && ! user.isActivated"
                @click="sendInvite(user)"
              >
                <i class="fa fa-envelope"></i>
              </button>
              <button type="button" class="btn btn-warning btn-sm"
                @click="openEditModal(user)"
              >
                <i class="fa fa-edit"></i>
              </button>
              <button type="button" class="btn btn-secondary btn-sm"
                @click="deleteUser(user)"
              >
                <i class="fa fa-trash-alt"></i>
              </button>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <cu-modal :modalContent="modalContent" v-if="modalContent"
      @userUpdated="userUpdated"
      @userStored="userStored"
    />
  </div>
</template>

<script>
  import { sortByName } from './../../helpers'
  import CuModal from './CuModal'
  import { datetime } from './../../filters'

  export default {
    props: ['initUsers'],
    components: { CuModal },
    data() {
      return {
        users: this.initUsers,
        userFilter: '',
        modalContent: null,
      }
    },
    filters: {
      datetime,
    },
    methods: {
      sendInvite(iUser) {
        window.axios.post(`/users/${iUser.id}/invite`).then(({data}) => {
          window.notification.success(`Email with instructions to account creation has been sent to ${iUser.name}`, 'Success!')
          const user = this.users.find(eUser => eUser.id === iUser.id)
          user.isInvited = data.isInvited
        })
      },
      deleteUser(user) {
        if (window.confirm(`Do you really want to delete the BManager ${user.name}?`)) {
          window.axios.delete(`/users/${user.id}`).then(({data}) => {
            window.notification.success(`${user.name} has been deleted`, 'Success!')
            const index = this.users.findIndex(eUser => eUser.id === user.id)
            this.users.splice(index, 1)
          })
        }
      },
      openEditModal(user) {
        this.modalContent = {
          title: `Edit ${user.name}`,
          formClassFields: user,
          submitMethod: 'put',
          submitUrl: `/users/${user.id}`,
          successEvent: 'userUpdated',
          submitText: 'Save',
          showInvite: false,
        }
        this.$nextTick(() => $('#cuModal').modal('show'))
      },
      openCreateModal() {
        this.modalContent = {
          title: `Create Kodak BManager`,
          formClassFields: {
            name: '',
            email: '',
            invite: true,
          },
          submitMethod: 'post',
          submitUrl: `/users`,
          successEvent: 'userStored',
          submitText: 'Create',
          showInvite: true,
        }
        this.$nextTick(() => $('#cuModal').modal('show'))
      },
      userUpdated(uUser) {
        window.notification.success(`${uUser.name} has been updated`, 'Success!')
        const user = this.users.find(eUser => eUser.id === uUser.id)
        user.name = uUser.name
        $('#cuModal').modal('hide')
      },
      userStored(user) {
        window.notification.success(`${user.name} has been created`, 'Success!')
        this.users.push(user)
        $('#cuModal').modal('hide')
      },
    },
    computed: {
      filteredUsers() {
        return this.users.filter(({name}) => name.toLowerCase()
          .indexOf(this.userFilter.toLowerCase()) > -1
        ).sort(sortByName)
      },
    },
    mounted() {
      $(document).on('hide.bs.modal', '#cuModal', () => this.modalContent = null)
    },
  }
</script>



// WEBPACK FOOTER //
// resources/js/components/users/UsersIndex.vue